module.exports = __webpack_public_path__ + "static/img/2.59c6ade.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/result/2.png
// module id = ScJp
// module chunks = 57